/** @format */
import { css } from 'styled-components';

const LINE_HEIGHT = '1.5em';
const BULLET_SIZE = '0.4rem';

const baseStyles = css`
    ul {
        display: flex;
        flex-direction: column;
        gap: var(--layout-spacing-8);
        padding: 0;
        list-style-type: none;
    }

    li {
        display: inline-flex;
    }

    li::before {
        content: '';
        display: flex;
        width: ${BULLET_SIZE};
        height: ${BULLET_SIZE};
        flex: 0 0 auto;
        border-radius: 100%;
        background-color: var(--colors-surface-inverse);
        margin-top: calc((${LINE_HEIGHT} - ${BULLET_SIZE}) / 2);
        margin-right: var(--layout-spacing-8);
    }
`;

export const styles = () => css`
    ${baseStyles}
`;
